import React, { useCallback } from "react";

import { faChevronRight } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import IntegrationService from "@mapmycustomers/shared/enum/integrations/IntegrationService";
import { Button } from "@mapmycustomers/ui";

import styles from "./ServiceButton.module.scss";

interface Props {
  className?: string;
  enabled: boolean;
  logo: string;
  name: string;
  onSelect?: (service: IntegrationService | undefined) => void;
  selectedService?: IntegrationService;
  shortName?: string;
  type: IntegrationService;
}

const ServiceButton: React.FC<Props> = ({
  className,
  enabled,
  logo,
  name,
  onSelect,
  selectedService,
  shortName,
  type,
}) => {
  const handleClick = useCallback(
    () => onSelect && onSelect(selectedService === type ? undefined : type),
    [onSelect, selectedService, type]
  );
  return (
    <Button
      className={cn(styles.container, className)}
      disabled={!enabled}
      onClick={handleClick}
      type={selectedService === type ? "primary" : "default"}
    >
      <div className={styles.content}>
        <img alt={name} className={styles.logo} src={logo} />
        <div className={styles.nameContainer}>
          {!enabled && (
            <span className={styles.comingSoon}>
              <FormattedMessage
                id="integrations.serviceButton.comingSoon"
                defaultMessage="Coming soon"
                description="Text of Coming soon"
              />
            </span>
          )}
          <p className={styles.name}>{shortName ?? name}</p>
        </div>
      </div>
      <FontAwesomeIcon icon={faChevronRight} size="lg" />
    </Button>
  );
};

export default ServiceButton;
